import styled from 'styled-components';

import { layout } from 'utils/styles/theme';

interface WrapperProps {}

const { threeFourth } = layout.columns;

export const Wrapper = styled.div<WrapperProps>`
  display: grid;
  grid-template-columns: repeat(${threeFourth}, 1fr);
  grid-column-gap: 32px;
`;

export const RightSide = styled.div`
  grid-column: 2 / 4;
`;
